import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import ActionButton from '../../../Components/Common/ActionButton';

const SubmitConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Submit this form?',
  message,
  confirmLabel = 'Submit',
  cancelLabel = 'Cancel',
  isSubmitting = false,
  showConfirm = true,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={onClose}
    centered
    className='border-0 rounded-4'
  >
    <ModalBody className='p-0'>
      <div className='text-center px-4 pt-5 pb-4'>
        <div
          className='bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4'
          style={{ width: '80px', height: '80px' }}
        >
          <i className='ri-folder-line fs-36 text-white'></i>
        </div>

        <h4 className='fw-bold text-dark mb-2'>
          {title || 'Submit this form?'}
        </h4>

        <p
          className='text-muted fs-14 px-3 mb-0'
          style={{ whiteSpace: 'pre-line' }}
        >
          {message ||
            'Once submitted, it is sent on for processing and can no longer be edited. This cannot be undone.'}
        </p>
      </div>

      <div className='border-top d-flex align-items-center justify-content-between p-3 bg-white rounded-bottom-4'>
        <ActionButton
          variant='tertiary'
          onClick={onClose}
          disabled={isSubmitting}
          className='px-4'
        >
          {cancelLabel || 'Cancel'}
        </ActionButton>

        {showConfirm && (
          <ActionButton
            variant='primary'
            onClick={onConfirm}
            loading={isSubmitting}
            className='px-5'
            style={{ minWidth: '160px' }}
          >
            {confirmLabel || 'Submit'}
          </ActionButton>
        )}
      </div>
    </ModalBody>
  </Modal>
);

export default SubmitConfirmModal;
